export default {
	title: 'Nastavení řešitele',
	superiorRadio: 'Přímo nadřízený uživatel',
	subordinateRadio: 'Přímo podřízený uživatel',
	usersRadio: 'Uživatel',
	agencyRadio: 'IDK oblast',
	marketPlaceRadio: 'Založit do tržiště',
	userName: 'Jméno uživatele',
	login: 'Login uživatele',
	sellerIn: 'Získatelské/Agenturní číslo',
	userFirstName: 'Jméno uživatele',
	userSurname: 'Příjmení uživatele',
	idkRegion: 'Region',
	idkAgency: 'Oblast',
	nonUniqueSolver: 'Upřesněte podmínky, aby zadaným informacím o řešiteli odpovídal právě jeden uživatel.',
};
